module.exports = __webpack_public_path__ + "img/logo.724547f1.png";